import { useContext } from "react";
import { getMediaAlphaHeadline } from "@/selectors";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { CompanyContext } from "../CompanyList/CompanyContext";

export const BaseMediaAlphaHeadline = ({ className }) => {
	const { company } = useContext(CompanyContext);
	const mediaAlphaHeadline = useSelector((state) =>
		getMediaAlphaHeadline(state, { company }),
	);
	if (!mediaAlphaHeadline) return null;

	return <div className={className}>{mediaAlphaHeadline}</div>;
};

BaseMediaAlphaHeadline.propTypes = {
	className: PropTypes.string,
};
